/**
 * Gets the language used for the map
 * @param languageCode - The language code
 * @returns The language to use on the map
 */
export const getMapLanguage = (languageCode: string) => {
  /* Hong Kong and Taiwan use traditional chinese */
  if (['zh-hk', 'zh-tw'].includes(languageCode.toLowerCase())) {
    return 'zh-Hant'
  }

  /* Mainland China uses simplified chinese */
  if (languageCode === 'zh') {
    return 'zh-Hans'
  }

  if (languageCode.includes('-')) {
    return languageCode.split('-')[0]
  }

  return languageCode
}
